// import React, { useEffect, useState } from "react";
// import PlaceServices from "../../services/externalServices/TourPackageServices/placeServices";
// import {
//   Box,
//   Card,
//   CardMedia,
//   CardContent,
//   Typography,
//   Divider,
//   Grid,
//   Tabs,
//   Tab,
//   Button,
//   IconButton,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import AddPlace from "./AddPlace"; // Import the AddPlace component
// import DeleteIcon from "@mui/icons-material/Delete";

// function Places() {
//   const [places, setPlaces] = useState([]);
//   const [filteredPlaces, setFilteredPlaces] = useState([]);
//   const [selectedTab, setSelectedTab] = useState(0); // Track selected tab
//   const [openAddPlaceDialog, setOpenAddPlaceDialog] = useState(false); // Dialog open state
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false); // Delete confirmation dialog state
//   const [placeToDelete, setPlaceToDelete] = useState(null); // Store the place to delete
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchAllPlaces();
//   }, []);

//   const fetchAllPlaces = async () => {
//     try {
//       const response = await PlaceServices.getPlaces();
//       setPlaces(response); // Assuming response is an array of places
//       filterPlaces(0, response); // Initialize with enabled places
//     } catch (error) {
//       console.log("error getting places", error);
//     }
//   };

//   const filterPlaces = (tabIndex, placesList) => {
//     const isEnabled = tabIndex === 0; // Enabled for tab 0, disabled for tab 1
//     const filtered = placesList.filter(
//       (place) => place.isEnabled === isEnabled
//     );
//     setFilteredPlaces(filtered);
//   };

//   const handleTabChange = (event, newValue) => {
//     setSelectedTab(newValue);
//     filterPlaces(newValue, places);
//   };

//   const handleCardClick = (placeId) => {
//     navigate(`/tourPackagePlaces/${placeId}`); // Navigate to the detail screen using the place ID
//   };

//   const handleAddPlaceDialogOpen = () => {
//     setOpenAddPlaceDialog(true);
//   };

//   const handleAddPlaceDialogClose = () => {
//     setOpenAddPlaceDialog(false);
//   };

//   // Open Delete Confirmation Dialog
//   const handleDeleteDialogOpen = (place) => {
//     setPlaceToDelete(place);
//     setOpenDeleteDialog(true);
//   };

//   // Close Delete Confirmation Dialog
//   const handleDeleteDialogClose = () => {
//     setOpenDeleteDialog(false);
//     setPlaceToDelete(null);
//   };

//   // Handle the deletion of a place
//   const handleDeletePlace = async () => {
//     if (placeToDelete) {
//       try {
//         await PlaceServices.deletePlace(placeToDelete._id); // Assuming a deletePlace service function exists
//         fetchAllPlaces(); // Refresh the list after deletion
//         handleDeleteDialogClose();
//       } catch (error) {
//         console.log("Error deleting place", error);
//       }
//     }
//   };

//   if (!places.length) return <Typography>Loading...</Typography>;

//   return (
//     <Box sx={{ p: 3 }}>
//       <Tabs
//         value={selectedTab}
//         onChange={handleTabChange}
//         centered
//         sx={{ marginBottom: 3 }}
//         textColor="primary"
//         indicatorColor="primary"
//       >
//         <Tab label="Enabled" />
//         <Tab label="Disabled" />
//       </Tabs>

//       <Button
//         variant="contained"
//         color="primary"
//         sx={{ mb: 3 }}
//         onClick={handleAddPlaceDialogOpen}
//       >
//         Add Place
//       </Button>

//       <Grid container spacing={3}>
//         {filteredPlaces.map((place) => (
//           <Grid item xs={12} sm={6} md={4} key={place._id}>
//             <Card
//               sx={{
//                 maxWidth: 345,
//                 borderRadius: 2,
//                 boxShadow: 3,
//                 cursor: "pointer",
//                 "&:hover": {
//                   boxShadow: 6,
//                   transform: "scale(1.05)",
//                   transition: "transform 0.3s, box-shadow 0.3s",
//                 },
//                 transition: "transform 0.3s, box-shadow 0.3s",
//               }}
//               onClick={() => handleCardClick(place._id)}
//             >
//               <CardMedia
//                 component="img"
//                 height="200"
//                 image={place.thumbnailImage}
//                 alt={place.shortName}
//                 sx={{ borderRadius: "5px 5px 0 0" }}
//               />
//               <CardContent>
//                 <Typography
//                   variant="h6"
//                   sx={{ fontWeight: 600, color: "#333" }}
//                   gutterBottom
//                 >
//                   {place.fullName}
//                 </Typography>
//                 <Typography
//                   variant="subtitle1"
//                   color="text.secondary"
//                   sx={{ mb: 1 }}
//                 >
//                   {place.shortName}
//                 </Typography>
//                 <Divider sx={{ mb: 2 }} />
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ fontSize: "0.875rem" }}
//                 >
//                   {place.description.length > 100
//                     ? `${place.description.substring(0, 100)}...`
//                     : place.description}
//                 </Typography>
//               </CardContent>
//               <IconButton
//                 sx={{
//                   position: "absolute",
//                   top: 10,
//                   right: 10,
//                   color: "rgba(0, 0, 0, 0.54)",
//                   "&:hover": {
//                     color: "red",
//                   },
//                 }}
//                 onClick={(e) => {
//                   e.stopPropagation(); // Prevent the card click event
//                   handleDeleteDialogOpen(place); // Open the delete dialog
//                 }}
//               >
//                 <DeleteIcon />
//               </IconButton>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* AddPlace Component */}
//       <AddPlace
//         openAddPlaceDialog={openAddPlaceDialog}
//         handleAddPlaceDialogClose={handleAddPlaceDialogClose}
//         fetchAllPlaces={fetchAllPlaces}
//       />

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={openDeleteDialog}
//         onClose={handleDeleteDialogClose}
//         aria-labelledby="delete-place-dialog-title"
//       >
//         <DialogTitle id="delete-place-dialog-title">
//           Confirm Deletion
//         </DialogTitle>
//         <DialogContent>
//           <Typography>Are you sure you want to delete this place?</Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDeleteDialogClose} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleDeletePlace} color="primary">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }

// export default Places;

import React, { useEffect, useState } from "react";
import PlaceServices from "../../services/externalServices/TourPackageServices/placeServices";
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Divider,
  Grid,
  Tabs,
  Tab,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddPlace from "./AddPlace";
import DeleteIcon from "@mui/icons-material/Delete";

function Places() {
  const [places, setPlaces] = useState([]);
  const [filteredPlaces, setFilteredPlaces] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState("en"); // Track selected language
  const [openAddPlaceDialog, setOpenAddPlaceDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [placeToDelete, setPlaceToDelete] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllPlaces();
  }, []);

  const fetchAllPlaces = async () => {
    try {
      const response = await PlaceServices.getPlaces();
      setPlaces(response);
      filterPlaces(0, response);
    } catch (error) {
      console.log("error getting places", error);
    }
  };

  const filterPlaces = (tabIndex, placesList) => {
    const isEnabled = tabIndex === 0;
    const filtered = placesList.filter(
      (place) => place.isEnabled === isEnabled
    );
    setFilteredPlaces(filtered);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    filterPlaces(newValue, places);
  };

  const handleCardClick = (placeId) => {
    navigate(`/tourPackagePlaces/${placeId}`);
  };

  const handleAddPlaceDialogOpen = () => {
    setOpenAddPlaceDialog(true);
  };

  const handleAddPlaceDialogClose = () => {
    setOpenAddPlaceDialog(false);
  };

  const handleDeleteDialogOpen = (place) => {
    setPlaceToDelete(place);
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setPlaceToDelete(null);
  };

  const handleDeletePlace = async () => {
    if (placeToDelete) {
      try {
        await PlaceServices.deletePlace(placeToDelete._id);
        fetchAllPlaces();
        handleDeleteDialogClose();
      } catch (error) {
        console.log("Error deleting place", error);
      }
    }
  };

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value); // Update the selected language
  };

  if (!places.length) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ p: 3 }}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        centered
        sx={{ marginBottom: 3 }}
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="Enabled" />
        <Tab label="Disabled" />
      </Tabs>

      {/* Language Dropdown */}
      <FormControl sx={{ mb: 3 }} fullWidth>
        <InputLabel id="language-select-label">Language</InputLabel>
        <Select
          labelId="language-select-label"
          value={selectedLanguage}
          onChange={handleLanguageChange}
          label="Language"
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="kn">Kannada</MenuItem>
          <MenuItem value="te">Telugu</MenuItem>
          <MenuItem value="ta">Tamil</MenuItem>
          <MenuItem value="ml">Malayalam</MenuItem>
          <MenuItem value="hi">Hindi</MenuItem>
        </Select>
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        sx={{ mb: 3 }}
        onClick={handleAddPlaceDialogOpen}
      >
        Add Place
      </Button>

      <Grid container spacing={3}>
        {filteredPlaces.map((place) => (
          <Grid item xs={12} sm={6} md={4} key={place._id}>
            <Card
              sx={{
                maxWidth: 345,
                borderRadius: 2,
                boxShadow: 3,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 6,
                  transform: "scale(1.05)",
                  transition: "transform 0.3s, box-shadow 0.3s",
                },
                transition: "transform 0.3s, box-shadow 0.3s",
              }}
              onClick={() => handleCardClick(place._id)}
            >
              <CardMedia
                component="img"
                height="200"
                image={place.thumbnailImage}
                alt={place.shortName[selectedLanguage]}
                sx={{ borderRadius: "5px 5px 0 0" }}
              />
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "#333" }}
                  gutterBottom
                >
                  {place.shortName[selectedLanguage] || place.shortName.en}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  {place.fullName[selectedLanguage] || place.fullName.en}
                </Typography>

                <Divider sx={{ mb: 2 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "0.875rem" }}
                >
                  {place.description[selectedLanguage]?.length > 100
                    ? `${place.description[selectedLanguage].substring(
                        0,
                        100
                      )}...`
                    : place.description[selectedLanguage]}
                </Typography>
              </CardContent>
              <IconButton
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "rgba(0, 0, 0, 0.54)",
                  "&:hover": {
                    color: "red",
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteDialogOpen(place);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* AddPlace Component */}
      <AddPlace
        openAddPlaceDialog={openAddPlaceDialog}
        handleAddPlaceDialogClose={handleAddPlaceDialogClose}
        fetchAllPlaces={fetchAllPlaces}
      />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        aria-labelledby="delete-place-dialog-title"
      >
        <DialogTitle id="delete-place-dialog-title">
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this place?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeletePlace} color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Places;
